import {
  Button,
  chakra,
  HTMLChakraProps,
  Input,
  Stack,
  Text,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";
import * as React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { subscribe } from "../../redux/actions/user/UserActions";
import { RootStore } from "../../redux/Store";
import { CLEAR_CONTACT_SUBSCRIBE_MESSAGE } from "../../redux/types/user/UserActionTypes";
import { FooterHeading } from "./FooterHeading";

export const SubscribeForm = (props: HTMLChakraProps<"form">) => {
  const dispatch = useDispatch();
  const [email, setemail] = useState("");
  const userState = useSelector((state: RootStore) => state.user);
  const toast = useToast();
  useEffect(() => {
    if (userState.message) {
      toast({
        title: "Subscription",
        description: userState.message,
        status: "success",
        duration: 2000,
        isClosable: true,
      });

      dispatch({ type: CLEAR_CONTACT_SUBSCRIBE_MESSAGE });
    }
  }, [userState.message]);
  return (
    <chakra.form
      {...props}
      onSubmit={(e) => {
        e.preventDefault();
        dispatch(subscribe(email));
        setemail("");
      }}
    >
      <Stack spacing="4">
        <FooterHeading color="white">Subscribe to our newsletter</FooterHeading>
        <Text>
          Get notified when we add new and exiciting profiles for you over here.
        </Text>
        <Stack spacing="4" direction={{ base: "column", md: "row" }}>
          <Input
            bg={useColorModeValue("white", "inherit")}
            color="black"
            value={email}
            onChange={(event) => {
              setemail(event.target.value);
            }}
            placeholder="Enter your email"
            type="email"
            id="SubscribeEmail"
            required
            focusBorderColor={useColorModeValue("blue.500", "blue.300")}
            _placeholder={{
              opacity: 1,
              color: useColorModeValue("gray.500", "whiteAlpha.700"),
            }}
          />
          <Button
            type="submit"
            colorScheme="blue"
            id="SubscribeButton"
            flexShrink={0}
            width={{ base: "full", md: "auto" }}
          >
            Subscribe
          </Button>
        </Stack>
      </Stack>
    </chakra.form>
  );
};
